// Add custom validator to check birthdate is more than 29 years ago
jQuery.validator.addMethod("minAge", function(value, element, min) {
	var today = new Date();
	today.setDate(today.getDate() + 365); // give 6 month additional time for those turning 35 soon
	var birthDate = new Date(value);
	var age = today.getFullYear() - birthDate.getFullYear();
	
	if(age > min+1) { return true; }
	
	var m = today.getMonth() - birthDate.getMonth();
	
	if(m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) { age--; }
	return age >= min;
}, function(params, element) { return "You must be turning " + jQuery(element).data('rule-minage') + " years old within 6 months." });

jQuery.validator.addMethod("zipcode", function(value, element) {
	return this.optional(element) || /^\d{5}(?:[\s-]\d{4})?$/.test(value);
}, "Please provide a valid zip code.");

jQuery.validator.addMethod("cbadzip", function(value, element) {
	return this.optional(element) || /^92008|92009|92010|92011|92013|92018$/.test(value);
}, "A Carlsbad address is required.");

jQuery.validator.addMethod("customcreditcard", function(value, element) {
	var el = jQuery(element).attr('id');
	var cardType;
	var validation = jQuery('#'+el).validateCreditCard({ accept: ['visa', 'mastercard', 'amex'] });
	cardType = (validation.card_type == null) ? '' : validation.card_type.name;
	jQuery('#'+el).removeClass('visa mastercard amex').addClass(cardType);
	return validation.valid;
}, "Please enter a valid credit card number.");

jQuery.validator.addMethod('ccexp', function(value, element, params) {
	var date = new Date();
	var minMonth = parseInt(('0' + (date.getMonth()+1)).slice(-2), 10);
	var minYear = parseInt(date.getFullYear(), 10);
	var month = parseInt(jQuery('#expMonth').val(), 10);
	var year = parseInt(jQuery('#expYear').val(), 10);
	if( !isNaN(month) && !isNaN(year) ){
		return (year > minYear || (year === minYear && month >= minMonth));
	}
	else{
		return;
	}
}, "Expiration date must be in the future.");

jQuery(document).ready(function($){
	$(document).foundation();
	
	const FLATPICKR_CUSTOM_YEAR_SELECT = 'flatpickr-custom-year-select';
	$('#birthdate, #lookup_birthdate').flatpickr({
		//altInput: true,
		//altFormat: "F j, Y",
		defaultDate: regBirthDate,
		dateFormat: "m/d/Y",
		minDate: "01/01/1900",
		maxDate: 'today',
		allowInput: true,
		onChange: function() {
			$('#birthdate').blur();
		},
    onReady: function (selectedDates, dateStr, instance) {
        const flatpickrYearElement = instance.currentYearElement;

        const children = flatpickrYearElement.parentElement.children;
        for (let i in children) {
            if (children.hasOwnProperty(i)) {
                children[i].style.display = 'none';
            }
        }

        const yearSelect = document.createElement('select');
        const minYear = new Date(instance.config._minDate).getFullYear();
        const maxYear = new Date(instance.config._maxDate).getFullYear();
        for (let i = minYear; i <= maxYear; i++) {
            const option = document.createElement('option');
            option.value = '' + i;
            option.text = '' + i;
            yearSelect.appendChild(option);
        }
        yearSelect.addEventListener('change', function (event) {
            flatpickrYearElement.value = event.target['value'];
            instance.currentYear = parseInt(event.target['value']);
            instance.redraw();
        });

        yearSelect.className = 'flatpickr-monthDropdown-months';
        yearSelect.id = FLATPICKR_CUSTOM_YEAR_SELECT;
        yearSelect.value = instance.currentYearElement.value;

        flatpickrYearElement.parentElement.appendChild(yearSelect);
    },
    onMonthChange: function (selectedDates, dateStr, instance) {
        document.getElementById(FLATPICKR_CUSTOM_YEAR_SELECT).value = '' + instance.currentYear;
    }
	});
	
	$('.mask-phone').inputmask({"mask": "(999) 999-9999"});
	
	$('.switch-input').on('change', function(event) {
		if(this.checked) {
			$(this).attr('checked', true);
		}
		else {
			$(this).attr('checked', false);
		}
	});
	
	$('.infield > input, .infield > textarea, .infield > select').each(function(){
		$(this).on('focus', function(){
			$(this).parent().addClass('focus');
		});
		
		$(this).on('blur', function(){
			$(this).parent().removeClass('focus');
		});
	});
	
	$('.cancel').on('click', function(e) {
		//e.preventDefault();
		var attr = $(this).attr('data-no-confirm');
		if(attr === undefined) {
			if(confirm('Are you sure you want to cancel and return the beginning?')) {
				Cookies.remove("regFormTab", {path: ''});
				return true;
			}
			else {
				return false;
			}
		}
	});
	
	$('#promo_code').on('change', function() {
		var url = registration_base_url + '/check-promo-code.php';
		$('#promo_code_wrapper').removeClass('isvalid notvalid')
		
		jQuery.ajax({
			type: "POST",
			url: url,
			dataType: 'JSON',
			data: {promo_code: $(this).val(), member_id: $('#member_id').val()},
			success: function(data){
				if(data.status == 'pass'){
					$('#promo_code_wrapper').removeClass('isvalid notvalid').addClass('isvalid');
					$('#promo_code_wrapper .promo-code--notification').removeClass('notvalid formerror').addClass('success');
				}
				else if(data.status == 'fail'){
					$('#promo_code_wrapper').removeClass('isvalid notvalid').addClass('notvalid');
					$('#promo_code_wrapper .promo-code--notification').removeClass('isvalid success').addClass('notvalid formerror');
				}
				
				$('#promo_code_wrapper .promo-code--notification').html(data.message);
/*
				if($('.promo-code--label span').length) {
					$('.promo-code--label span').remove();
				}
				$('.promo-code--label').append(data.message);
*/
			},
			error: function(xhr, textStatus, errorThrown){
				console.log(textStatus);
			}
		});
	});
	if($('#promo_code').length && $('#promo_code').val() != '') {
		$('#promo_code').trigger('change');
	}
	
	// July 4th
	$('#participating_state_cup').on('change', function() {
		if ($('#participating_football').is(':checked')) {
			$('#participating_football').prop('checked', false);
		}
	});
	$('#participating_football').on('change', function() {
		if ($('#participating_state_cup').is(':checked')) {
			$('#participating_state_cup').prop('checked', false);
		}
	});
	$('#attendees').on('change', function() {
		console.log($(this).val());
		if ($(this).val() > 1 ) {
			$('#additional_participants_wrapper').show();
		} else {
			$('#additional_participants_wrapper').hide();
		}
	}).trigger('change');
	$('#additional_participants').on('change', function() {
		if ($(this).val() > 0) {
			$('#participant_waiver_wrapper').show();
		} else {
			$('#participant_waiver_wrapper').hide();
		}
	}).trigger('change');
});
	
/*
jQuery(document)
	.ajaxStart(function(){
		jQuery('#loading').show();
	})
	.ajaxStop(function(){
		jQuery('#loading').hide();
	});
*/

var x = jQuery("form.multi-step").find(".fs-step");
var form = jQuery("form.multi-step").attr("id");
var fields = jQuery("form.multi-step .form-field");
var currentTab; // = 0; // Current tab is set to be the first tab (0)
var progress = jQuery(".progress-bar").find(".step");
var oneHour = 1/24;

if(jQuery("form.multi-step").length){
	// Set session for showing correct tab on load
	if(Cookies.get("regFormTab") !== undefined){
		currentTab = x.filter('#'+Cookies.get("regFormTab")).index('.fs-step');
	}
	else {
		currentTab = 0;
		Cookies.set("regFormTab", "step1", { path: '' });
	}
}

function setSession() {
	var url = registration_base_url + '/set-session.php';
	jQuery.ajax({
		type: "POST",
		url: url,
		data: jQuery('#'+form).find(':visible').serialize(),
		success: function(data){
			//console.log(data);
		},
		error: function(xhr, textStatus, errorThrown){
			console.log(textStatus);
		}
	});
}

function progressBar(n) {
	jQuery(".progress-bar-wrapper").css('display', 'block');
	for(var i=0; i<progress.length; i++){
		if(i < n){
			jQuery(progress[i]).removeClass('step--incomplete step--active').addClass('step--complete');
		}
		else if(i == n){
			jQuery(progress[i]).removeClass('step--incomplete step--complete').addClass('step--active');
		}
		else {
			jQuery(progress[i]).removeClass('step--active step--complete').addClass('step--incomplete');
		}
	}
	jQuery(progress[n]).removeClass('step--incomplete step--complete').addClass('step--active');
}

function showFormStep(n) {
	// This function will display the specified tab of the form ...
	var submitLabel = (form == 'membershipForm' ? 'Submit' : 'Verify');
	var tab_id = jQuery(x[n]).attr("id");
	Cookies.set("regFormTab", tab_id, { path: '' });
	jQuery('.fs-step').not('#'+tab_id).removeClass('active').addClass('inactive');
	jQuery('#'+tab_id).removeClass('inactive').addClass('active');
	
	jQuery('html, body').animate({ scrollTop: jQuery('.progress-bar-wrapper').offset().top - 25}, 500);
	
	// autofocus the first field
	jQuery(':input:visible:enabled:first').focus();
	
	// ... and run a function that displays the correct step indicator:
	progressBar(n);
}

function nextPrev(n) {
	setSession();
	// This function will figure out which tab to display
	var x = jQuery('.fs-step'); // document.getElementsByClassName("tab");
	//var id = jQuery($step).attr('id'); //jQuery(x[n]).attr('id'); //x[currentTab].id;
	// Exit the function if any field in the current tab is invalid:
	if (n == 1 && !jQuery('#'+form).valid()) { return false; } //jQuery('#membershipForm').foundation('validateForm')
	// Hide the current tab:
	jQuery(x[currentTab]).addClass('inactive').removeClass('active');//x[currentTab].style.display = "none";
	// Increase or decrease the current tab by 1:
	currentTab = currentTab + n;
	// if you have reached the end of the form... :
	if (currentTab >= x.length) {
		//...the form gets submitted:
		//document.getElementById("regForm").submit();
		//return false;
	}
	// Otherwise, display the correct tab:
	showFormStep(currentTab);
}